import { REQUEST_LOADING_STATES } from "../../../helpers/constant";
import { IQuickFileAlbums, IQuickFileData, IQuickFileQueryParams } from "../../../helpers/types";
import { useNavigate } from "react-router-dom";
import QuickFileListRow from "./QuickFileListRow/QuickFileListRow";
// import MediaIcon from '@/assets/icons/double-files-purple-bg.svg';
// import AudioIcon from '@/assets/icons/audio-purple-bg.svg';

import MediaIcon from "../../../assets/icons/double-files-purple-bg.svg";
import AudioIcon from "../../../assets/icons/audio-purple-bg.svg";

import { useTranslation } from "react-i18next";
import DeleteQuickFileAlbumModal from "../../../components/quickFiles/modals/DeleteQuickFileAlbumModal/DeleteQuickFileAlbumModal";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { quickFileService } from "../../../services/quickFile.service";
import { useRef, useState } from "react";
import { message } from "antd";
import "./QuickFileView.less";
import Loader from "../../../components/loader/Loader";
import dateUtil from "../../../utls/DateUtil";
import i18next from "i18next";

interface Props {
  quickFiles: any | null;
  loading: REQUEST_LOADING_STATES;
  queryParams: IQuickFileQueryParams;
  onAlbumSelect?: (albumId: string) => void;
  filterType?: "audio" | "photos-videos";
}

const QuickFileList = ({ quickFiles, loading, queryParams, onAlbumSelect, filterType }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [albumIdToDelete, setAlbumIdToDelete] = useState<string>("");
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const pressTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const longPressTriggeredRef = useRef<boolean>(false);

  const filteredAlbums = (quickFiles || []).filter((a: any) => !filterType || a.type === filterType);

  const handleForwardNavigation = (item: IQuickFileAlbums) => {
    if (onAlbumSelect) {
      onAlbumSelect(item.id);
      return;
    }
    if (queryParams?.id) {
      if (queryParams?.id === "mediaPush") {
        navigate(
          `/creator/AlbumFeeds/${item.id}?id=${queryParams?.id}&conversationId=${queryParams.conversationId}&messageId=${queryParams.messageId}&receiverId=${queryParams.receiverId}`
        );
      } else if (queryParams?.id === "collection") {
        navigate(`/creator/AlbumFeeds/${item.id}?id=${queryParams?.id}&collectionTitle=${queryParams.collectionTitle}`);
      } else if (queryParams?.id === "conversation" || queryParams?.id === "pendingMedia") {
        navigate(
          `/creator/AlbumFeeds/${item.id}?id=${queryParams?.id}&conversationId=${queryParams.conversationId}&messageId=${queryParams?.messageId}`
        );
      } else if (queryParams?.id === "automation") {
        navigate(`/creator/AlbumFeeds/${item.id}?id=${queryParams?.id}&block=${queryParams?.block}`);
      } else if (queryParams?.id === "chatScripts") {
        navigate(`/creator/AlbumFeeds/${item.id}?id=${queryParams?.id}&conversationId=${queryParams.conversationId}`);
      } else {
        navigate(`/creator/AlbumFeeds/${item.id}?id=${queryParams?.id}&conversationId=${queryParams.conversationId}`);
      }
    } else {
      if (filterType === "photos-videos") navigate("/creator/AlbumFeeds/" + item.id);
      else
        navigate("/creator/AlbumFeeds/" + item.id + "/audios", {
          state: { albumName: item.name },
        });
    }
  };

  const startPressTimer = (albumId: string) => {
    clearPressTimer();
    pressTimerRef.current = setTimeout(() => {
      setAlbumIdToDelete(albumId);
      setDeleteModalOpen(true);
      longPressTriggeredRef.current = true;
    }, 2000);
  };

  const clearPressTimer = () => {
    if (pressTimerRef.current) {
      clearTimeout(pressTimerRef.current);
      pressTimerRef.current = null;
    }
  };

  return (
    <>
      {loading === REQUEST_LOADING_STATES.PENDING ? (
        <Loader />
      ) : (
        <div className="qf-list" style={{ touchAction: "pan-y" }}>
          {filteredAlbums.length ? (
            filteredAlbums.map((item: any) => (
              <div
                key={item.id}
                onMouseDown={() => startPressTimer(item.id)}
                onMouseUp={clearPressTimer}
                onMouseLeave={clearPressTimer}
                onTouchStart={() => startPressTimer(item.id)}
                onTouchEnd={clearPressTimer}
                onTouchCancel={clearPressTimer}
              >
                <QuickFileListRow
                  leadingIcon={item.type === "audio" ? AudioIcon : MediaIcon}
                  title={item.name}
                  subtitle={dateUtil.formatSimpleDate(item.createdAt, i18next.language)}
                  count={item.filesNumber}
                  onClick={() => {
                    if (longPressTriggeredRef.current) {
                      longPressTriggeredRef.current = false;
                      return;
                    }
                    handleForwardNavigation(item);
                  }}
                />
              </div>
            ))
          ) : (
            <div className="qf-empty">{t(filterType === "audio" ? "no-audio-albums" : "no-photo-video-albums")}</div>
          )}
        </div>
      )}
      <DeleteQuickFileAlbumModal
        isOpen={deleteModalOpen}
        onCancel={() => {
          if (!isDeleting) {
            setDeleteModalOpen(false);
          }
        }}
        onConfirm={async () => {
          if (albumIdToDelete && !isDeleting) {
            setIsDeleting(true);
            try {
              await quickFileService.deleteAlbum(albumIdToDelete);
              message.success(t("album-deleted-successfully"));
              setDeleteModalOpen(false);
              window.location.reload();
            } catch (error: any) {
              message.error(error || t("back-error-message"));
            } finally {
              setIsDeleting(false);
            }
          }
        }}
        isDeleting={isDeleting}
      />
    </>
  );
};

export default QuickFileList;
